import * as React from "react";
import { useContext } from "react";
import { Form, TextArea } from "semantic-ui-react";
import { QAPropsBase } from "../State";
import { changeFn, store } from "../store";

// tslint:disable-next-line: interface-name
interface Props {
    index: number;
    propsBase: QAPropsBase;
    onChange?: changeFn;
}

const CheckboxAnswer: React.FunctionComponent<Props> = (props: Props) => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  return (
        <div>
            <TextArea style={{maxWidth: "300px", resize: "none"}} readOnly value={props.propsBase.label} />
            <Form.Checkbox key={`${props.index}`} id={`${props.index}`}
              // tslint:disable-next-line: max-line-length
              onChange={(e, d) => dispatch({ type: "handle answer update", index: props.index, value: d.checked, validator: props.propsBase.answerValidator })}
                style={{marginTop: "20px"}}
                label={"I agree with the statement above"} />
        </div>
    );
  };

export default CheckboxAnswer;
